import { render, staticRenderFns } from "./RegistrationStep3.vue?vue&type=template&id=e897983c&scoped=true"
import script from "./RegistrationStep3.vue?vue&type=script&lang=js"
export * from "./RegistrationStep3.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep3.vue?vue&type=style&index=0&id=e897983c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e897983c",
  null
  
)

export default component.exports